var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11.3161 15.5878L17.0161 9.88785C17.4241 9.47985 17.4241 8.81985 17.0161 8.39985C16.6081 7.99185 15.9361 7.99185 15.5281 8.39985L10.5721 13.3558L8.47208 11.2558C8.06408 10.8478 7.39208 10.8478 6.98408 11.2558C6.57608 11.6638 6.57608 12.3238 6.98408 12.7438L9.84008 15.5878C10.0441 15.7918 10.3081 15.8878 10.5721 15.8878C10.8481 15.8878 11.1121 15.7918 11.3161 15.5878Z",
    fill: "#00C68E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTick);
export default __webpack_public_path__ + "static/media/circle-tick.70e884098d9fbe94683d0d4a59183c7e.svg";
export { ForwardRef as ReactComponent };